import { defaultModalProps } from 'modal-tpyes'
import {
  useMediaQuery,
  useTheme,
  Dialog,
  makeStyles,
  Container,
  Typography,
  Box,
  Grid,
  Button
} from '@material-ui/core'
import React , { useState, useEffect } from 'react'
// import { useSelector, StateProps} from 'react-redux'
import { useHistory } from 'react-router-dom'

interface stylesProp {
  useMobileUI:boolean
}

const useStyles = makeStyles((theme)=>({
  root: (props:stylesProp) => ({
    borderRadius: theme.spacing(1) ,
    backgroundColor: "white",
    margin:"0px",
    minWidth: props.useMobileUI? "0":"100%",
    padding:"16px"
  }),
  closeIcon : {
    position: "absolute",
    color: theme.palette.primary.main,
    top: theme.spacing(2),
    left: theme.spacing(3),
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  textBlack: {
    color: "#000"
  },
  confirmSvg: {
    fill: theme.palette.primary.main,
    justifyItems:"center"
  },
}))

interface props {
  modelName : string,
  isSubSuccess : boolean,
  message : string
  accountId : string
}

const ModelSubConfirmModal:React.FC<defaultModalProps> = ({
  open,
  handleBack,
  handleClose,
  props:modalProps,
}) => {

  const theme = useTheme();
  const useMobileUI = useMediaQuery(theme.breakpoints.up("sm"));
  const styleProps = { useMobileUI: useMobileUI };
  const classes = useStyles(styleProps);
  const [props,setProps] = useState<props>()
  const [timeLeft, setTimeLeft] = useState(0);
  const history = useHistory();

  useEffect(() => {
    if (open) setTimeLeft(5);
  }, [open]);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (timeLeft >= 1) {
        setTimeLeft((timeleft) => timeleft - 1);
      }
      if (timeLeft === 1) {
        // setModel("");
        onClose();
      }
    }, 1000);
    return () => clearTimeout(timer);
  });

  const onClose = () => {
    setTimeLeft(0)
    history.push(`/portfolio?accid=${props?.accountId||"default"}`)
    handleClose()
  }

  const ModalProps = {
    paper: classes.root,
  };

  useEffect(()=>{
    if (modalProps) {
      let props:props = {
        isSubSuccess: modalProps.isSubSuccess,
        message : modalProps.message,
        modelName : modalProps.modelName,
        accountId : modalProps.accountId,
      }
      setProps(props)
    }
  },[modalProps])


  return (
    <Dialog open={open||false}  keepMounted onClose={onClose} classes={ModalProps} maxWidth="xl">
      <Container maxWidth="md" >
        <Box paddingX={6} paddingY={3}>
          {props&&
          <Typography align="center" className={classes.textBlack} variant="h6">
             {props.isSubSuccess ? 
             <Grid container alignItems="center" direction="column">
              <svg
              width="84"
              height="84"
              viewBox="0 0 84 84"
              xmlns="http://www.w3.org/2000/svg"
              className={classes.confirmSvg}
            >
              <path d="M61.1252 23.583L33.6668 51.0413L18.7085 36.1247L12.8335 41.9997L33.6668 62.833L67.0002 29.4997L61.1252 23.583ZM42.0002 0.333008C19.0002 0.333008 0.333496 18.9997 0.333496 41.9997C0.333496 64.9997 19.0002 83.6664 42.0002 83.6664C65.0002 83.6664 83.6668 64.9997 83.6668 41.9997C83.6668 18.9997 65.0002 0.333008 42.0002 0.333008ZM42.0002 75.333C23.5835 75.333 8.66683 60.4163 8.66683 41.9997C8.66683 23.583 23.5835 8.66634 42.0002 8.66634C60.4168 8.66634 75.3335 23.583 75.3335 41.9997C75.3335 60.4163 60.4168 75.333 42.0002 75.333Z" />
            </svg>
            <Box mt={4}/>
            <Typography variant="subtitle1">คุณได้ติดตาม {props?.modelName} เรียบร้อยแล้ว</Typography>
            </Grid>
              :
              `${props?.message}`
            }
          </Typography>}
        </Box>
        {/* <Box mt={2}/> */}
        <Grid container justifyContent="center">
          <Button 
            variant="contained" 
            color="primary"
            onClick={onClose}
            href={`portfolio?accid=${props?.accountId||"default"}`}
          >{`กลับไปหน้าเดิมใน ${timeLeft} วินาที`}</Button>
        </Grid>
        <Box mb={4}/>
      </Container>
    </Dialog>
  )
}

export default ModelSubConfirmModal